import axios from "axios";
import { parseCookies } from "nookies";

const cookies = parseCookies(); // Get cookies
console.log("cookies ==========>", cookies);
const token = cookies.reebukToken; // Retrieve token

console.log("token", token);

export const postApiCaller = async (endPoint, body) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, body, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};
export const postApiCallerFormData = async (endPoint, formData) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, formData, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const getApiCaller = async (endPoint) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.get(url, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const getApiWithBodyCaller = async (endPoint) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.get(url, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteApiCaller = async (endPoint) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.get(url, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};
